<template>
  <dialog-scroll-lock :value="true" width="400" @input="$emit('input', false)">

    <error-dialog :status="showStatus" />

    <v-card>
      <v-btn class="float-right mt-3 mr-3" icon @click="$emit('input', false)">
        <v-icon v-html="mdiClose" />
      </v-btn>

      <v-card-title class="pa-4">Specify amount</v-card-title>
      <v-card-subtitle v-if="(order.n_giftcard_recipients || 1) > 1" class="mt-n5 px-4 pb-6">
        This gift card will be sent to {{order.n_giftcard_recipients | pl('recipient')}}
      </v-card-subtitle>
      <v-card-subtitle class="px-4 mt-0">
        <v-card class="float-right ml-4 mb-1 gc-border" width="100">
          <v-img :aspect-ratio="337 / 213" :src="blob.giftcard.product_img" />
        </v-card>
        <div class="overline short" style="color: rgba(0, 0, 0, 0.87);" v-html="blob.giftcard.product_name" />
        <giftcard-details :src="blob.giftcard.src" :product-id="blob.giftcard.product_id" />
      </v-card-subtitle>
      <div style="clear: both;" />
      <div class="px-4 pb-4" v-bind:class="{ 'pt-4': blob.giftcard.allowed_values.fixed }">
        <v-form
          v-model="stagedGiftcardAmtValid"
          @submit.prevent="
            () => {
              if (stagedGiftcardAmtValid) {
                blob.giftcard.amt = stagedGiftcardAmt;
                $emit('input', false);
              }
            }
          "
        >
          <giftcard-amount
            :allowed-values="blob.giftcard.allowed_values"
            :cur="blob.giftcard.cur"
            :max="maxGiftcardValueRemaining"
            v-model="stagedGiftcardAmt"
          />
        </v-form>
      </div>
      <template v-if="noAmtValid">
        <v-divider />
        <v-card-text class="error--text font-italic pa-4">Max gift card value is restricted to <currency :code="blob.giftcard.cur" />{{maxGiftcardValue}} – there are no valid values that can be assigned to this gift card. Please try a different one.</v-card-text>
      </template>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="$emit('input', false)">Cancel</v-btn>
        <v-btn
          color="primary"
          :disabled="!stagedGiftcardAmtValid"
          @click="blob.giftcard.amt = stagedGiftcardAmt; $emit('input', false);"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </dialog-scroll-lock>
</template>

<script>
import Currency from '@/components/Currency.vue';
import GiftcardAmount from '@/components/GiftcardAmount.vue';
import GiftcardDetails from '@/components/GiftcardDetails.vue';
import { mdiClose, mdiInformation, mdiFileDocument } from '@mdi/js';

export default {
  name: 'giftcard-edit-dialog',

  components: {
    Currency,
    GiftcardAmount,
    GiftcardDetails
  },

  props: {
    order: Object,
    blob: Object,
    maxGiftcardValue: Number,
    maxGiftcardValueRemaining: Number
  },

  data() {
    return {
      product: null,
      productKey: null,
      stagedGiftcardAmt: null,
      stagedGiftcardAmtValid: false,
      showStatus: this.$track('show')
    };
  },

  computed: {
    noAmtValid() {
      if (!this.blob)
        return false;
      const allowed = this.blob.giftcard.allowed_values;
      const min = allowed.range ? allowed.range.min : Math.min(...allowed.fixed);
      return this.maxGiftcardValue < min;
    }
  },

  created() {
    Object.assign(this, { mdiClose, mdiInformation, mdiFileDocument });
  },

  watch: {
    blob: {
      immediate: true,
      handler(v) {
        this.stagedGiftcardAmt = v.giftcard.amt;
      }
    }
  }
}
</script>
